<template>
    <div>
        <draggable
            v-model="nodesClone"
            v-bind="dragOptions"
            @start="drag = true"
            @end="drag = false"
            @change="orderChange()"
            :disabled="locked"
        >
            <div v-for="node in nodesClone" :key="node.id" class="menu-item">
                <div class="nav-item parent" :id="'node' + node.id" :ref="'ref' + node.id">
                    <router-link
                        :id="'listnode' + node.id"
                        :to="caseBaseUrl + 'nodes/' + node.id + '/'"
                        @click.native="itemSelect()"
                        active-class="active"
                        :exact="false"
                        class="nav-link ml-0 pr-2 node-list-link"
                    >
                        <span>
                            <span style="margin-right: 4px">{{ node.number }}.</span>
                            <span>{{ node.title }}</span></span
                        >
                    </router-link>
                </div>
            </div>
        </draggable>
    </div>
</template>

<script>
import draggable from "vuedraggable"

export default {
    name: "NodeLinkList",
    props: {
        nodes: {
            type: Array,
            required: true,
        },
        caseBaseUrl: {
            type: String,
            required: true,
        },
        locked: {
            type: Boolean,
            required: false,
        },
    },
    components: {
        draggable,
    },
    data() {
        return {
            dragOptions: {
                // Need to disable the animation, it messes with the
                // node link svg rendering.
                animation: 0,
                ghostClass: "ghost",
                delay: 500,
                delayOnTouchOnly: true,
            },
            nodesClone: this.nodes,
        }
    },
    watch: {
        nodes(newValue) {
            this.nodesClone = newValue
        },
    },
    methods: {
        // Collapse the sidenav on small screens when an item is selected.
        itemSelect() {
            if (window.innerWidth < 1000) {
                $("#sidebarCollapse").collapse("hide")
            }
        },
        orderChange() {
            let vm = this
            // Emit the new order of the nodes - wait for the nexttick to
            // make sure the list has re-rendered.
            this.$nextTick(() => {
                vm.$emit("update-order", this.nodesClone)
            })
        },
    },
    updated: function () {
        // Emit an event every time the node list is re-rendered. Using
        // the nexttick function to make sure the event is emitted when the
        // component is fully rendered.
        this.$nextTick(function () {
            this.$emit("updated")
        })
    },
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables";
@import "@/assets/styles/mixins";

$sidenav-link: $gray-700;
$sidenav-background: #fff;
$sidenav-background-active: #f1f4f7;
$sidenav-font-parent: 14px;
$sidenav-font-child: 0.875rem;
$sidenav-btn-radius: $border-radius-sm;

.nav-item.parent {
    padding-right: 0px;

    @media (min-width: $sidenav-collapse) {
        padding-right: 1px;
    }
}

.nav-link {
    color: $sidenav-link;
    padding: 0.25rem 0.75rem;
    font-size: $sidenav-font-parent;
    font-weight: 500;
    margin-left: 16px;
    margin-right: 16px;
    border-radius: $sidenav-btn-radius;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.active {
        color: $primary;

        @media (min-width: $sidenav-collapse) {
            background-color: $sidenav-background-active !important;
        }
    }

    &:hover {
        background-color: $sidenav-background-active;
    }

    &.disabled {
        color: $gray-500;
        pointer-events: none;
    }

    &.parent {
        &.collapsed {
            &::after {
                @include caret;
                float: right;
                margin-top: 0.8rem;
                transform: initial;
            }
        }

        &::after {
            @include caret;
            transform: rotate(180deg);
            float: right;
            margin-top: 0.6rem;
        }
    }

    &.child {
        padding-left: 44px;
        font-size: $sidenav-font-child;
        font-weight: normal;

        &.disabled {
            color: $gray-600;
            pointer-events: none;
        }

        &:hover {
            background-color: $gray-300;
        }
    }
}

li {
    width: 100%;
}

.node-list-link {
    padding-top: 0.28rem;
    padding-bottom: 0.28rem;
    padding-left: 5px;
}
</style>